import { useMap } from 'react-map-gl';
import { useTranslation } from 'react-i18next';
import { useMeasureDistanceToolState } from '../../state/useMeasureDistanceToolState';
import { usePoisState } from '../../state/usePoisState';
import { useKeyboardShortcuts } from './useKeyboardShortcuts';

export const useMapDistanceToolKeyboardShortcut = (): void => {
  const { isToolActive, activateTool } = useMeasureDistanceToolState();
  const { setSelectedPoi } = usePoisState();
  const mapRef = useMap().current;
  const { t } = useTranslation();

  const handleKeyboardShortcut = (): void => {
    const center = mapRef?.getCenter();

    if (!center || !mapRef) {
      return;
    }

    activateTool({ lat: center.lat, lng: center.lng }, mapRef);

    setSelectedPoi({
      type: 'measureTool',
      metadata: null,
    });
  };

  useKeyboardShortcuts(
    [
      {
        category: 'mapTools',
        description: t('keyboardShortcuts.mapTools.measureDistance'),
        keys: 't m',
        handler: handleKeyboardShortcut,
      },
    ],
    [isToolActive],
  );
};
